<div
  class="modal-bg-overlay"
  *ngIf="showBackgroundMask"
  [style.zIndex]="zIndex"
  (click)="handleClickOutside()"
  [style.visibility]="visibility"></div>

<div
  #element
  *ngIf="show"
  class="modal-element popup"
  [class.isGrabbed]="isGrabbed"
  [class.isResized]="isResized"
  [class.isPinned]="isPinned"
  [class.noDraggable]="fullScreen || !isDraggable || isMaximized"
  [style.width.px]="_width"
  [style.height.px]="_height"
  [style.top.px]="_top"
  [style.left.px]="_left"
  [style.minWidth.px]="minWidth"
  [style.minHeight.px]="minHeight"
  [style.maxWidth.px]="maxWidth ? maxWidth : ''"
  [style.maxHeight.px]="maxHeight ? maxHeight : ''"
  [style.zIndex]="zIndex"
  [style.visibility]="visibility"
  [style.position]="'fixed'">
  <ng-content></ng-content>

  <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>

  <div class="resize-line top" (mousedown)="enableResize($event, grabPlaces.top)"></div>
  <div class="resize-line right" (mousedown)="enableResize($event, grabPlaces.right)"></div>
  <div class="resize-line bottom" (mousedown)="enableResize($event, grabPlaces.bottom)"></div>
  <div class="resize-line left" (mousedown)="enableResize($event, grabPlaces.left)"></div>

  <div class="resize-handle bottom-left" (mousedown)="enableResize($event, grabPlaces.bottomLeft)"></div>
  <div class="resize-handle top-left" (mousedown)="enableResize($event, grabPlaces.topLeft)"></div>
  <div class="resize-handle top-right" (mousedown)="enableResize($event, grabPlaces.topRight)"></div>
  <div class="resize-handle bottom-right" (mousedown)="enableResize($event, grabPlaces.bottomRight)"></div>
</div>
